import React from 'react';
export default function UnreadIndicator(_ref) {
  var fillColour = _ref.fillColour,
    halfFill = _ref.halfFill;
  return /*#__PURE__*/React.createElement("svg", {
    "data-testid": "unread-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "none",
    height: "24px"
  }, halfFill && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "4",
    stroke: fillColour
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "cut-off-left"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "0",
    width: "12",
    height: "24"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "4",
    fill: fillColour,
    clipPath: halfFill ? 'url(#cut-off-left)' : undefined
  }));
}